__turbopack_context__.v({
  "main": "PerformanceLabChrome-module__HfnLxq__main",
});
